import { makeVar } from '@apollo/client';
/**
 * This represents the current users active on the document.
 */
export const documentUsers = makeVar([]);
